import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(private toastService: ToastService) {}

  handleError(error: HttpErrorResponse): void {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.error);
      this.toastService.showError('Client Error', error.error.error);
    } else {
      switch (error.status) {
        case 400:
          this.toastService.showError('Bad Request (400)', error.error.error);
          break;
        case 401:
          // Owned by AuthInterceptor (clears the session, redirects, shows
          // a "Session expired" toast). Re-toasting here produces a double
          // toast — see implementation-guidelines §11.1 + §12.3.
          break;
        case 403:
          this.toastService.showWarn('Forbidden (403)', error.error.error);
          break;
        case 404:
          this.toastService.showError('Not Found (404)', error.error.error);
          break;
        case 500:
          this.toastService.showError('Server Error (500)', 'An internal server error occurred.');
          break;
        default:
          this.toastService.showError(`Unexpected Error (${error.status})`, 'An unexpected error occurred.');
      }
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
  }
}
